import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { __experimentalBlockSettingsMenuPluginsExtension } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
/**
 * Internal dependencies
 */

import ConvertToGroupButton from './convert-button';

function ConvertToGroupButtons(_ref) {
  var clientIds = _ref.clientIds;
  return createElement(__experimentalBlockSettingsMenuPluginsExtension, null, function (_ref2) {
    var onClose = _ref2.onClose;
    return createElement(Fragment, null, createElement(ConvertToGroupButton, {
      clientIds: clientIds,
      onToggle: onClose
    }));
  });
}

export default withSelect(function (select) {
  var _select = select('core/block-editor'),
      getSelectedBlockClientIds = _select.getSelectedBlockClientIds;

  return {
    clientIds: getSelectedBlockClientIds()
  };
})(ConvertToGroupButtons);
//# sourceMappingURL=index.js.map